import { render, staticRenderFns } from "./comingsoon.vue?vue&type=template&id=3d81c7c6&"
import script from "./comingsoon.vue?vue&type=script&lang=js&"
export * from "./comingsoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports